import { XMarkIcon } from '@heroicons/react/24/outline';
import type { ComponentProps } from 'react';
import { Button } from './Button';

/** 閉じる/削除用の XMarkIcon アイコンボタン */
type CloseButtonProps = Omit<ComponentProps<'button'>, 'children'> & {
  /** aria-label（省略時は「閉じる」） */
  'aria-label'?: string;
};

const CloseButton = ({ className, onClick, ...props }: CloseButtonProps) => (
  <Button
    type="button"
    variant="ghost"
    size="icon"
    className={className}
    onClick={(e) => {
      e.stopPropagation();
      onClick?.(e);
    }}
    aria-label={props['aria-label'] ?? '閉じる'}
    {...props}
  >
    <XMarkIcon className="h-4 w-4" />
  </Button>
);

CloseButton.displayName = 'CloseButton';

export { CloseButton };
